import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { controlContainerProvider } from '../../constants/control-container-provider';
import {
  GpuFormFieldAppearance,
  GpuFormFieldModule,
} from '@geneplanet/ngx-ui/src/lib/form-field';
import {
  ngbDateFromDate,
  ngbDateToISO,
  subtractCurrentDateYear,
} from 'src/app/shared/util/date-util';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AnalyticsService } from '@geneplanet/ngx-utils/src/lib/analytics';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-questionnaire-date',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    GpuFormFieldModule,
    NgbDatepickerModule,
  ],
  templateUrl: './questionnaire-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [controlContainerProvider],
})
export class QuestionnaireDateComponent implements OnInit, OnDestroy {
  @Input({ required: true }) formFieldAppearance: GpuFormFieldAppearance;
  @Input({ required: true }) questionnaireId: string;

  protected now = ngbDateFromDate(new Date());
  protected minDate = ngbDateFromDate(subtractCurrentDateYear(10));

  private parentContainer = inject(ControlContainer);
  private analyticsService = inject(AnalyticsService);

  get form() {
    return this.parentContainer.control as FormGroup;
  }

  ngOnInit(): void {
    this.form.addControl(
      'date',
      new FormControl(this.now, Validators.required)
    );
    this.trackDate();
  }

  ngOnDestroy(): void {
    this.form.removeControl('date');
  }

  private trackDate() {
    const control = this.form.controls.date;
    control.valueChanges
      .pipe(filter(Boolean), untilDestroyed(this))
      .subscribe(() => {
        this.analyticsService.trackFormValue(
          'analyses-add',
          'date',
          {
            value: ngbDateToISO(this.form.controls.date.value),
          },
          this.questionnaireId
        );
      });
  }
}
